import type { Business } from "@/features/business/types/businessTypes";
import { FormBusinessBoundary } from "../components/FormBusinessBoundary";
import { FormEditor } from "../components/FormEditor";
import { useCreateForm } from "../hooks/formQueries";

function CreateForm({ business }: { business: Business }) {
  const mutation = useCreateForm(business.id);
  return <FormEditor businessId={business.id} businessName={business.name} onSave={request => mutation.mutateAsync(request)} />;
}

export function FormCreatePage() {
  return <FormBusinessBoundary title="Create form">{business => <CreateForm key={business.id} business={business} />}</FormBusinessBoundary>;
}
